import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";

import CompleteAdminProfile from "./modules/admin/pages/completeAdminProfile";

import InvoiceDesign from "./modules/admin/pages/invoiceDesign";
import TestimonialTable from "./modules/admin/pages/testimonial/list";
import TestimonialAdd from "./modules/admin/pages/testimonial/add";
import TestimonialView from "./modules/admin/pages/testimonial/view";
import TestimonialEdit from "./modules/admin/pages/testimonial/edit";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteLayout from "./modules/website/shared/layout";
// import WebsiteHomePage from "./modules/website/pages/homePage";
import SwayydPage from "./modules/website/pages/SwayydPage";
import SwayydLayout from "./modules/website/shared/swayydLayout";
import WebsiteContactPage from "./modules/website/pages/contactPage";
// import WebsiteFaqPage from "./modules/website/pages/faqPage";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQView from "./modules/admin/pages/cms/faq/view";
import contactUsTable from "./modules/admin/pages/cms/contactUs/list";
import contactUsView from "./modules/admin/pages/cms/contactUs/view";
import PhotoroomUsageTable from "./modules/admin/pages/photoroomUsage/list";
import ReportedPostsTable from "./modules/admin/pages/cms/reportedPosts/list";
import ReportedPostsView from "./modules/admin/pages/cms/reportedPosts/view";
import PostsTable from "./modules/admin/pages/cms/posts/list";
import PostView from "./modules/admin/pages/cms/posts/view";
import CustomerTable from "./modules/admin/pages/customerManagement/customers/list";
import CustomerView from "./modules/admin/pages/customerManagement/customers/view";
import CategoryTable from "./modules/admin/pages/category/list";
import CategoryView from "./modules/admin/pages/category/view";
import CategoryEdit from "./modules/admin/pages/category/edit";
import CategoryAdd from "./modules/admin/pages/category/add";
import BrandTable from "./modules/admin/pages/brand/list";
import BrandView from "./modules/admin/pages/brand/view";
import BrandEdit from "./modules/admin/pages/brand/edit";
import BrandAdd from "./modules/admin/pages/brand/add";
import SubcategoryTable from "./modules/admin/pages/subCategory/list";
import SubcategoryView from "./modules/admin/pages/subCategory/view";
import SubcategoryEdit from "./modules/admin/pages/subCategory/edit";
import SubcategoryAdd from "./modules/admin/pages/subCategory/add";
import ItemTable from "./modules/admin/pages/itemManagement/list";
import ItemView from "./modules/admin/pages/itemManagement/view";
import OutfitTable from "./modules/admin/pages/outfitManagement/list";
import OutfitView from "./modules/admin/pages/outfitManagement/view";
import SubscriptionTable from "./modules/admin/pages/subscriptionManagement/list";
import SubscriptionView from "./modules/admin/pages/subscriptionManagement/view";
import SubscriptionEdit from "./modules/admin/pages/subscriptionManagement/edit";
import SubscriptionAdd from "./modules/admin/pages/subscriptionManagement/add";
import UserSubscriptionTable from "./modules/admin/pages/userSubscriptionManagement/list";
import UserSubscriptionView from "./modules/admin/pages/userSubscriptionManagement/view";
import IapTransactionTable from "./modules/admin/pages/iapTransactionManagement/list";
import IapTransactionView from "./modules/admin/pages/iapTransactionManagement/view";
import WebsitePrivacyPage from "./modules/website/pages/privacy";
import WebsiteTermsPage from "./modules/website/pages/terms";
import BackgroundRemoval from "./modules/admin/pages/testimonial/backgroundImage";

const router = createBrowserRouter([
  // { path: "/inquiry", element: <Enquire /> },

  {
    path: "/",
    element: <SwayydLayout />,
    children: [
      {
        path: "",
        element: <SwayydPage />,
      },
      { path: "privacy-policy", element: <WebsitePrivacyPage /> },
      { path: "terms", element: <WebsiteTermsPage /> },
      {
        path: "contact-us",
        element: <WebsiteContactPage />,
      },
      // {
      //   path: "faq",
      //   element: <WebsiteFaqPage />,
      // },
    ],
  },

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "invoice-design",
        element: <PrivateRoute component={InvoiceDesign} />,
      },
      {
        path: "profile",
        // element: <Profile />,
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            // element: <EditProfile />,
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            // element: <Changepassword />,
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },
      {
        /**testimonial management route start */
      },
      {
        path: "testimonial-management/testimonial/list/:pgno",
        element: <TestimonialTable />,
      },
      {
        path: "testimonial-management/testimonial/view/:id",
        element: <TestimonialView />,
      },
      {
        path: "testimonial-management/testimonial/add",
        element: <TestimonialAdd />,
      },
      {
        path: "testimonial-management/testimonial/:pgno/edit/:id",
        element: <TestimonialEdit />,
      },
      {
        /**testimonial management route end */
      },

      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={PageTable} />,
      },
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={PageAdd} />,
      },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={PageEdit} />,
      },
      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={PageView} />,
      },

      {
        path: "cms/banner/list/:pgno",
        element: <PrivateRoute component={BannerTable} />,
      },
      {
        path: "cms/banner/add",
        element: <PrivateRoute component={BannerAdd} />,
      },
      {
        path: "cms/banner/:pgno/edit/:id",
        element: <PrivateRoute component={BannerEdit} />,
      },
      {
        path: "cms/banner/view/:id",
        element: <PrivateRoute component={BannerView} />,
      },

      {
        path: "cms/settings",
        element: <PrivateRoute component={GlobalSettings} />,
      },

      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={EmailTemplatesTable} />,
      },
      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={EmailTempAdd} />,
      },
      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={EmailTempEdit} />,
      },
      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={ViewEmailTemp} />,
      },

      {
        path: "cms/faq/list/:pgno",
        element: <PrivateRoute component={FAQTable} />,
      },
      {
        path: "cms/faq/add",
        element: <PrivateRoute component={FAQAdd} />,
      },
      {
        path: "cms/faq/:pgno/edit/:id",
        element: <PrivateRoute component={FAQEdit} />,
      },
      {
        path: "cms/faq/view/:id",
        element: <PrivateRoute component={FAQView} />,
      },

      {
        path: "cms/contactUs/list/:pgno",
        element: <PrivateRoute component={contactUsTable} />,
      },

      {
        path: "cms/contactUs/view/:id",
        element: <PrivateRoute component={contactUsView} />,
      },
      {
        path: "photoroom-usage/list/:pgno",
        element: <PrivateRoute component={PhotoroomUsageTable} />,
      },
      {
        path: "reportedPosts/list/:pgno",
        element: <PrivateRoute component={ReportedPostsTable} />,
      },
      {
        path: "reportedPosts/view/:id",
        element: <PrivateRoute component={ReportedPostsView} />,
      },
      {
        path: "posts/list/:pgno",
        element: <PrivateRoute component={PostsTable} />,
      },
      {
        path: "posts/view/:id",
        element: <PrivateRoute component={PostView} />,
      },
      {
        path: "customerManagement/customers/list/:pgno",
        element: <PrivateRoute component={CustomerTable} />,
      },
      {
        path: "customerManagement/customers/view/:id",
        element: <PrivateRoute component={CustomerView} />,
      },
      {
        path: "category/list/:pgno",
        element: <PrivateRoute component={CategoryTable} />,
      },
      {
        path: "category/view/:id",
        element: <PrivateRoute component={CategoryView} />,
      },
      {
        path: "category/:pgno/edit/:id",
        element: <PrivateRoute component={CategoryEdit} />,
      },
      {
        path: "category/add",
        element: <PrivateRoute component={CategoryAdd} />,
      },
      {
        path: "brand/list/:pgno",
        element: <PrivateRoute component={BrandTable} />,
      },
      {
        path: "brand/view/:id",
        element: <PrivateRoute component={BrandView} />,
      },
      {
        path: "brand/:pgno/edit/:id",
        element: <PrivateRoute component={BrandEdit} />,
      },
      {
        path: "brand/add",
        element: <PrivateRoute component={BrandAdd} />,
      },

      {
        path: "subcategory/list/:pgno",
        element: <PrivateRoute component={SubcategoryTable} />,
      },
      {
        path: "subcategory/view/:id",
        element: <PrivateRoute component={SubcategoryView} />,
      },
      {
        path: "subcategory/:pgno/edit/:id/:categoryId",
        element: <PrivateRoute component={SubcategoryEdit} />,
      },
      {
        path: "subcategory/add",
        element: <PrivateRoute component={SubcategoryAdd} />,
      },
      {
        path: "itemManagement/list/:pgno",
        element: <PrivateRoute component={ItemTable} />,
      },
      {
        path: "itemManagement/view/:id",
        element: <PrivateRoute component={ItemView} />,
      },
      {
        path: "outfitManagement/list/:pgno",
        element: <PrivateRoute component={OutfitTable} />,
      },
      {
        path: "outfitManagement/view/:id",
        element: <PrivateRoute component={OutfitView} />,
      },
      {
        path: "subscriptionManagement/list/:pgno",
        element: <PrivateRoute component={SubscriptionTable} />,
      },
      {
        path: "subscriptionManagement/view/:id",
        element: <PrivateRoute component={SubscriptionView} />,
      },
      {
        path: "subscriptionManagement/:pgno/edit/:id",
        element: <PrivateRoute component={SubscriptionEdit} />,
      },
      {
        path: "subscriptionManagement/add",
        element: <PrivateRoute component={SubscriptionAdd} />,
      },
      {
        path: "userSubscriptions/list/:pgno",
        element: <PrivateRoute component={UserSubscriptionTable} />,
      },
      {
        path: "userSubscriptions/view/:id",
        element: <PrivateRoute component={UserSubscriptionView} />,
      },
      {
        path: "transactions/list/:pgno",
        element: <PrivateRoute component={IapTransactionTable} />,
      },
      {
        path: "transactions/view/:id",
        element: <PrivateRoute component={IapTransactionView} />,
      },

      {
        path: "backgroundRemoval/list/:pgno",
        element: <PrivateRoute component={BackgroundRemoval} />,
      },
      /** Email Logs Routing End*/
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },
]);

export default router;
